import axios from "network";
import { Page } from "../models";

export const getPage = async (pageId: number): Promise<Page> => {
  return axios.get(`/pages/${pageId}`).then(response => response.data);
};
